import styled from 'styled-components'

export const Main = styled.main`
  width: 850px;
  margin: 0 auto 32px;
  display: grid;
  grid-template-columns: 100%;
  padding: 16px;
  max-width: 100vw;

  & > * {
    margin-bottom: 24px;
  }
`
